import { Box } from '@mantine/core'

const DriveOriginIframe = ({ latitude, longitude }: { latitude?: number; longitude?: number }) => {
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || window.ENV?.GOOGLE_MAPS_API_KEY

  const iframeKey = latitude && longitude ? `${latitude.toFixed(6)},${longitude.toFixed(6)}` : 'empty'

  return (
    <Box
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '533.33px',
        paddingBottom: '56.25%',
        height: 0,
        overflow: 'hidden',
        maxHeight: '300px',
        margin: '0 auto',
        borderRadius: '8px',
      }}
      mb="sm"
    >
      <iframe
        key={iframeKey}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${latitude?.toFixed(6)},${longitude?.toFixed(6)}&zoom=16`}
        allowFullScreen
      />
    </Box>
  )
}

export default DriveOriginIframe
